module.exports = __webpack_public_path__ + "assets/images/gli_r.a46bb346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/gli_r.png
// module id = 718
// module chunks = 1